var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActualize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455:335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58006 1.20998C2.45006 3.63998 2.00006 7.67998 1.95006 8.62998H0.410064C0.0800641 8.62998 -0.109936 9.00998 0.0900642 9.27998L3.92006 14.38L7.75006 9.27998C7.95006 9.00998 7.76006 8.62998 7.43006 8.62998H6.00006C6.06006 4.52998 7.81006 1.95998 10.6001 1.20998C13.8601 0.32998 16.2601 2.08998 16.2601 2.08998C15.1601 0.88998 11.0601 -1.43002 6.58006 1.20998Z",
    fill: "#8F95AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.31 3.19L21.14 8.29C21.34 8.56 21.15 8.94 20.82 8.94H13.81C13.48 8.94 13.29 8.56 13.49 8.29L17.31 3.19Z",
    fill: "#CCD0DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.28 8.72998C19.28 8.72998 19.36 13.59 14.64 16.36C10.16 19 6.05996 16.68 4.95996 15.48C4.95996 15.48 7.35996 17.24 10.62 16.36C13.46 15.59 15.23 12.96 15.23 8.72998H19.28Z",
    fill: "#CCD0DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455:335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.22,
    height: 17.57,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActualize);
export default __webpack_public_path__ + "static/media/actualize.814a9e7d.svg";
export { ForwardRef as ReactComponent };